/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-empty-function */
/* eslint-disable flowtype/no-types-missing-file-annotation */
import moment from "moment";
import React, { useEffect, useState, FC, useContext, useMemo } from "react";
import { useSelector } from "react-redux";

import { STATUS } from "../../../../../../socket/config";
import {
    SocketContext,
    useSocket,
} from "../../../../../../socket/socket.context";
import {
    accountService,
    callService2,
    accountService2,
    meetService,
} from "../../../../../../service";
import { goToRoomWithToken } from "../../../../../../utils";
import {
    Icon,
    IconGroup,
    IconIncomingCall,
    IconMissedCall,
    IconOutgoingCall,
} from "../../../../base/icons";

import RecentCallItemAvatar from "./RecentCallItemAvatar";
import NewRecentItemViewDispalyName from "./NewRecentItemViewDispalyName";
import OldRecentItemViewDispalyName from "./OldRecentItemViewDispalyName";

export interface RecentCallItemProps {
    item: PhoneBookData;
    index: number;
    onSelectUser: () => void;
}

const RecentCallItem: FC<RecentCallItemProps> = (props) => {
    const { item, index, onSelectUser } = props;
    const { user } = useSelector((state) => state["features/settings"]);
    const socketContext = useSocket();
    const { usersStatus, sendUserStatus } = useContext(SocketContext);

    const status = usersStatus ? usersStatus[item?.id] : undefined;


    let iconCall = IconIncomingCall;
    let color = "gray";

    switch (item?.callType) {
        case "inbound": {
            iconCall = IconIncomingCall;
            break;
        }
        case "outbound": {
            iconCall = IconOutgoingCall;
            break;
        }
        case "missed": {
            iconCall = IconMissedCall;
            break;
        }
    }

    switch (status) {
        case STATUS.ONLINE: {
            color = "green";
            break;
        }
        case STATUS.OFFLINE: {
            color = "gray";
            break;
        }
        case STATUS.BUSY: {
            color = "red";
            break;
        }
        case STATUS.DND: {
            color = "yellow";
            break;
        }
        case undefined: {
            color = "gray";
            break;
        }
    }
    const ifAnyContactOrGroupDeleted = (item) => {
        let deleteItem = false;
        if (!item.isGroupCall) {
            item?.contacts?.map((contact, index) => {
                if (!contact.user) {
                    deleteItem = true;
                }
            });
        } else {

            item?.groups?.map((group, index) => {
                if (!group.name) {
                    deleteItem = true;
                }
            });
    }
        return deleteItem;
    };
    const handleCall = async (item) => {
        if (ifAnyContactOrGroupDeleted(item)) {
            // if the contact is not valid, don't try to call it
            return;
        }

        const timeZone = moment.tz.guess();
        console.log(item)
        if (user.id && item.id) {
            socketContext.sendUserStatus(user.id, STATUS.BUSY);
            const ringNames = [];

            item.receivers.map((receiver) => {
                if (receiver?.user?.firstName) {
                    ringNames.push(receiver.user.firstName);
                }
            });

            let ringName;

            if (ringNames.length > 1) {
                console.log(ringNames.slice(0, 2).join(",").concat(",etc..."));
                ringName = ringNames.slice(0, 2).join(",").concat(",etc...");
            } else {
                console.log(ringNames.join(","));
                ringName = ringNames.join(",");
            }

            await callService2
                .createCallFromHistory(item.id, timeZone)
                .then(async (res) => {
                    const meeting = await meetService.createMeeting(
                        res?.data?.callingHistory?.id,
                        `${user.firstName} ${user.lastName}`,
                        user.email,
                        user.id
                    );
                    const meetingrest = await meetService.getMeetingData(
                        meeting?.data?.id
                    );

                    sendUserStatus(user.id, STATUS.BUSY);
                    goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
                    let ringTone = false

                    item.groups.map(group=>{
                        group.contacts.map(contact=>{
                            if(contact?.permissionLevel !==2){
                                ringTone = true;
                            }
                        })
                    })

                    item.contacts.map(contact=>{
                        if(contact?.user?.permissionLevel !==2){
                            ringTone = true;
                        }
                    })
                    if(ringTone){
                    sessionStorage.setItem(
                        `ringing-${res.data?.callingHistory?.id}`,
                        true
                    );
                    sessionStorage.setItem(
                        `ringing-${res.data?.callingHistory?.id}-firstName`,
                        ringName
                    );
                    }
                });
        }
    };
    const multipleSelectRecentCallList = (item, index) => {
        if (ifAnyContactOrGroupDeleted(item)) {
            return;
        }
        onSelectUser(item, index);
    };

    const getGroupUsers = (item) => {
        let names = '';
        {item?.receivers?.length && item.receivers.map((receiver, index) => {
           if(index === 0) {
            names = receiver?.user?.firstName || "Deleted" + " " + receiver?.user?.lastName || "User"; 
           }
        })}
        if (item.receivers?.length > 1) {
            names = names + ', and ' + (item.receivers?.length - 1) + ' more...'
        }
        return names;
    }

    return (
        <div className={"o-user-list-item--wrapper"}>
            <div
                className="o-user-list-item-container"
                key={item?.id}
                onClick={() => handleCall(item, index)}
            >
                <div className={"dis-flex ali-center flex-1"}>
                    <RecentCallItemAvatar color={color} item={item} />
                    {item?.version === 2 && (
                        <div style={{width: '100%'}}>
                            <NewRecentItemViewDispalyName item={item} />
                            {item?.isGroupCall && 
                                <p className="o-user-list-item-receiver">{getGroupUsers(item)}</p>
                            }
                        </div>
                    )}
                </div>
                <Icon size={20} src={iconCall} />
            </div>
            <button
                className="o-phone-book-item-btn mt-10 ml-10"
                onClick={() => multipleSelectRecentCallList(item, index)}
            >
                {item?.isContact ? 
                    <div className="o-phone-book-item-dot" />
                 : null}
            </button>
        </div>
    );
};
RecentCallItem.defaultProps = {};

export default RecentCallItem;
